module.exports = __webpack_public_path__ + "img/link.1f463674.svg";